import { Constant } from "src/app/common/constant";

export const FO_ROUTES: any[] = [
  {
    path: Constant.url_agent_investors_list,
    title: "Nhà đầu tư",
    type: "INVESTOR",
    count: 0,
    icon: "assets/images/icon/ic-fail.png",
    permission: "INVESTOR",
    submenu: [
      // {
      //   path: Constant.url_agent_investors_list,
      //   title: 'Danh sách',
      //   icon: 'assets/images/icon/icon-menu.svg',
      //   permission: 'INVESTOR',
      //   submenu: []
      // },
    ],
  },
  {
    path: Constant.url_agent_user_doc,
    title: "Hồ sơ",
    type: "USER_DOC",
    count: 0,
    icon: "assets/images/icon/icon-search.png",
    permission: "PROFILE",
    submenu: [
      // {
      //   path: Constant.url_agent_user_doc_approved_kyc_profile,
      //   title: 'NĐT chờ KYC',
      //   icon: 'assets/images/icon/icon-menu.svg',
      //   permission: 'PROFILE_KYC',
      //   submenu: []
      // },
      {
        path: Constant.url_agent_user_doc_kyc,
        title: "KYC (NĐT Việt Nam)",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "PROFILE_KYC",
        submenu: [],
      },
      {
        path: Constant.url_agent_user_doc_kyc_for_foreign,
        title: "KYC (NĐT nước ngoài)",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "PROFILE_KYC",
        type: "FOREIGN_INVESTOR",
        submenu: [],
      },
      {
        path: Constant.url_agent_user_doc_vsd,
        title: "Trung tâm lưu ký",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "PROFILE_VSD",
        submenu: [],
      },
      // {
      //   path:  Constant.url_agent_user_doc_pending_profile_on_vsd,
      //   title: 'Hồ sơ chờ lên VSD',
      //   icon: 'assets/images/icon/icon-menu.svg',
      //   permission: 'PROFILE_KYC',
      //   submenu: []
      // },
      // {
      //   path: Constant.url_agent_user_doc_profile_on_vsd,
      //   title: 'VSD',
      //   icon: 'assets/images/icon/icon-menu.svg',
      //   permission: 'PROFILE_VSD',
      //   submenu: []
      // },
      {
        path: Constant.url_agent_user_doc_list_not_updated_investors,
        title: "Chưa cập nhật",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "PROFILE_NOT_UPDATE",
        submenu: [],
      },
      {
        path: Constant.url_agent_user_doc_survey_ipo,
        title: "Khảo sát IPO",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "PROFILE_IPO",
        submenu: [],
      },
    ],
  },
  {
    path: Constant.url_agent_transaction,
    title: "Giao dịch",
    type: "TRANSACTION",
    count: 0,
    icon: "assets/images/icon/icon-menu.svg",
    permission: "ORDER",
    submenu: [
      {
        path: Constant.url_agent_admin_transaction,
        title: "Danh sách giao dịch",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "ORDER_LIST",
        submenu: [],
      },
      {
        path: Constant.url_agent_pending_transaction,
        title: "Lệnh chờ",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "ORDER_PENDING",
        submenu: [],
      },
      {
        path: Constant.url_agent_detail_transaction,
        title: "Chi tiết lệnh",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "ORDER_DETAIL",
        submenu: [],
      },
      {
        path: Constant.url_agent_import_file,
        title: "Nhập File lệnh",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "ORDER_IMPORT",
        submenu: [
          // {
          //   path: Constant.url_agent_import_file_new_transaction,
          //   title: 'Tạo lệnh mới',
          //   icon: 'assets/images/icon/icon-menu.svg',
          //   permission: 'ORDER_IMPORT',
          //   submenu: []
          // },
          // {
          //   path: Constant.url_agent_import_file_check_status,
          //   title: 'Kiểm tra trạng thái lệnh',
          //   icon: 'assets/images/icon/icon-menu.svg',
          //   permission: 'ORDER_IMPORT',
          //   submenu: []
          // },
        ],
      },
      {
        path: Constant.url_agent_history_transaction,
        title: "Lịch sử giao dịch",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "ORDER_HISTORY",
        submenu: [],
      },
      {
        path: Constant.url_agent_transfer_asset,
        title: "Chuyển tài sản",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "ORDER_HISTORY",
        submenu: [],
      },
    ],
  },
  {
    path: "",
    title: "Đăng ký SIP",
    type: "SIP",
    count: 0,
    icon: "assets/images/icon/icon-menu.svg",
    permission: "SIP",
    submenu: [
      {
        path: Constant.url_agent_investors_register_sip,
        title: "Xác nhận đăng ký",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "SIP_LIST",
        submenu: [],
      },
      {
        path: Constant.url_agent_register_sip,
        title: "Lệnh đăng ký",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "SIP_REGISTER",
        submenu: [],
      },
    ],
  },
  {
    path: Constant.url_change_information,
    title: "Thông tin thay đổi",
    type: "CHANGE_INFORMATION",
    count: 0,
    icon: "assets/images/icon/icon-menu.svg",
    permission: "CHANGE_INFO",
    submenu: [
      {
        path: Constant.url_change_information_confirm_change_profile,
        title: "Xác nhận thay đổi thông tin",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "INVESTOR",
        sumbenu: [],
      },
      {
        path: Constant.url_change_information_confirm_change_name,
        title: "Xác nhận thay đổi tên",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "INVESTOR",
        sumbenu: [],
      },
      {
        path: Constant.url_change_information_bank,
        title: "Tài khoản ngân hàng",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "CHANGE_INFO_BANK",
        submenu: [],
      },
      {
        path: Constant.url_change_information_idCard,
        title: "CMND/CCCD/MST/ĐKKD",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "CHANGE_INFO_ID_CARD",
        submenu: [],
      },
      {
        path: Constant.url_change_information_phone,
        title: "Số điện thoại",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "CHANGE_INFO_PHONE",
        submenu: [],
      },
      {
        path: Constant.url_change_information_email,
        title: "Email",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "CHANGE_INFO_EMAIL",
        submenu: [],
      },
      {
        path: Constant.url_change_information_private,
        title: "Thông tin cá nhân",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "CHANGE_INFO_PERSONAL",
        submenu: [],
      },
      {
        path: Constant.url_change_information_sign,
        title: "Hồ sơ ký thay đổi thông tin",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "CHANGE_INFO_ESIGN_PAPER",
        submenu: [],
      },
      {
        path: Constant.url_export_fatca,
        title: "Export Fatca",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "CHANGE_INFO_ESIGN_PAPER",
        submenu: [],
      },
    ],
  },
  {
    path: Constant.url_products_nav_list,
    title: "NAV",
    icon: "assets/images/icon/icon-menu.svg",
    permission: "PRODUCT_NAV",
    submenu: [],
  },
  {
    path: "",
    title: "Đối soát",
    type: "RECONCILE",
    count: 0,
    icon: "assets/images/icon/icon-menu.svg",
    permission: "RECONCILE",
    submenu: [
      {
        path: Constant.url_agent_reconcile_reconciled_transactions,
        title: "Đối soát lệnh",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "RECONCILE_VSD",
        submenu: [],
      },
      // {
      //   path: Constant.url_agent_reconcile_agent_transaction_tabs,
      //   title: 'Đối soát đại lý',
      //   icon: 'assets/images/icon/icon-menu.svg',
      //   permission: 'RECONCILE_AGENT',
      //   submenu: []
      // },
      // {
      //   path: Constant.url_agent_reconcile_vsd_transaction_tabs,
      //   title: 'Đối soát VSD',
      //   icon: 'assets/images/icon/icon-menu.svg',
      //   permission: 'RECONCILE_VSD',
      //   submenu: []
      // },
      {
        path: Constant.url_agent_history_reconcile_transaction,
        title: "Lịch sử đối soát",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "RECONCILE_HISTORY",
        submenu: [],
      },
      {
        path: Constant.url_agent_statistic_transaction,
        title: "Thống kê vàng",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "ORDER_STATISTIC",
        submenu: [],
      },
    ],
  },
  {
    path: Constant.url_agent_report,
    title: "Báo cáo",
    type: "REPORT",
    count: 0,
    icon: "assets/images/icon/icon-menu.svg",
    permission: "REPORT",
    submenu: [
      {
        path: Constant.url_agent_asset_report,
        title: "Báo cáo tài sản",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "REPORT_ASSET",
        submenu: [],
      },
      {
        path: Constant.url_agent_fee_report,
        title: "Báo cáo phí",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "REPORT_FEE",
        submenu: [
          // {
          //   path: Constant.url_agent_fee_report_issuer,
          //   title: 'Phí cho tổ chức phát hành',
          //   icon: 'assets/images/icon/icon-menu.svg',
          //   permission: 'REPORT_FEE',
          //   submenu: []
          // },
          // {
          //   path: Constant.url_agent_fee_report_agent,
          //   title: 'Phí cho đại lý',
          //   icon: 'assets/images/icon/icon-menu.svg',
          //   permission: 'REPORT_FEE',
          //   submenu: []
          // },
        ],
      },
    ],
  },
  {
    path: "",
    title: "Tools",
    type: "TOOL",
    count: 0,
    icon: "assets/images/icon/icon-menu.svg",
    permission: "",
    submenu: [
      {
        path: Constant.url_agent_tools_split_pdf,
        title: "Tách file PDF",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "",
        submenu: [],
      },
      {
        path: Constant.url_agent_tools_export_suggest_auto_payment,
        title: "Giấy đề nghị TĐTT",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "",
        submenu: [],
      },
      {
        path: Constant.url_agent_tools_check_asset,
        title: "Kiểm tra tài sản",
        icon: "assets/images/icon/icon-menu.svg",
        permission: "",
        submenu: [],
      },
    ]
  }
];
